/**
 * Generates a cryptographically secure random token
 * @param length Length of the token to generate (default: 32)
 * @returns Generated token string
 */
export function generateToken(length: number = 32): string {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * Formats a token string with dashes for better readability
 * @param token Raw token string
 * @param groupLength Length of each group (default: 8)
 * @returns Formatted token string
 */
export function formatToken(token: string, groupLength: number = 8): string {
  if (!token) return '';
  const groups = token.match(new RegExp(`.{1,${groupLength}}`, 'g')) || [];
  return groups.join('-');
}